import MainNav from './MainNav';

export default MainNav;
